import * as React from 'react';
import * as ReactDOM from 'react-dom';
import getSkypeApi from '../chatManager/getSkypeApi';
import { getStore } from '../../store/chatStore';
import { observer } from 'mobx-react-lite';

const styles = require('./UcwaChatView.scss');
let skypeRootNode: HTMLElement = null;

const UcwaChatView = observer(function UcwaChatView() {
    React.useEffect(() => {
        getSkypeApi().then(skypeApi => {
            skypeApi.renderContent(selectDomClass(styles.contentPane));
            skypeApi.renderSidebar(selectDomClass(styles.sideBar));
        });
    }, []);

    const isShown = getStore().isChatCalloutShown;

    return (
        <div
            className={styles.swx}
            style={{
                display: isShown ? '' : 'none',
            }}>
            <div>
                <div className={styles.contentPane} />
                <div className={styles.sideBar} />
            </div>
        </div>
    );
});

function selectDomClass(className: string) {
    return '.' + className;
}

// Due the the implementation of SWX, if we mount it inside flex pane, it will not work correctly
// after close and reopen flex pane. The way to keep it working is to keep it mounted in DOM tree
// and we just hide it when close flex pane.
// So that we mout it separately, and make it appear on top of flex pane.
export default function mountSkypeIfNeed(forceRemount?: boolean) {
    if (skypeRootNode && forceRemount) {
        ReactDOM.unmountComponentAtNode(skypeRootNode);
        skypeRootNode = null;
    }

    if (!skypeRootNode) {
        skypeRootNode = document.createElement('DIV');
        document.body.appendChild(skypeRootNode);
        ReactDOM.render(<UcwaChatView />, skypeRootNode);
    }
}
